'use client'

import React from 'react'

import { Spinner } from '@rewardops/ui'
import { type CategorySummaryData } from '@rewardops/utils'

import BrandsListFilter from '~/components/maple/filters/brands-list-filter'
import CategoriesFilter from '~/components/maple/filters/categories-filter'
import FilterBase from '~/components/maple/filters/filter-base'
import PricePointFilter from '~/components/maple/filters/price-point-filter'
import { useTranslation } from '~/app/i18n/client'
import CategoriesListFilter from './filters/categories-list-filter'
import EarnRatesFilter from './filters/earn-rates-filter'

interface MapleFilterBarProps {
  isLoading?: boolean
  isPontsRangeEnabled?: boolean
  mainCategoryName?: string | undefined
  brandsOptions?: any[]
  categoriesOptions?: any[]
  subCategories?: CategorySummaryData[] | undefined
  earnRateOptions?: any[]
}

const SideFilters = ({
  isLoading = false,
  isPontsRangeEnabled = true,
  mainCategoryName,
  brandsOptions,
  categoriesOptions,
  subCategories,
  earnRateOptions,
}: MapleFilterBarProps) => {
  const { t } = useTranslation()

  if (isLoading) {
    return <Spinner className="container mx-auto mt-4" />
  }

  return (
    <div className="flex w-[16rem] flex-col pr-4">
      <FilterBase
        title={t('filters.categories')}
        openByDefault={true}
        shouldBeHidden={
          !categoriesOptions?.length || categoriesOptions?.length == 0
        }
      >
        <CategoriesListFilter
          categories={categoriesOptions ?? []}
          searchEnabled={false}
        />
      </FilterBase>

      <FilterBase
        title={mainCategoryName || t('filters.category')}
        openByDefault={true}
        shouldBeHidden={!subCategories || subCategories?.length == 0}
      >
        <CategoriesFilter categories={subCategories} />
      </FilterBase>
      {isPontsRangeEnabled ? (
        <FilterBase
          title={t('filters.pointsRange')}
          openByDefault={true}
          showTopSeparator={false}
        >
          <PricePointFilter />
        </FilterBase>
      ) : null}
      <FilterBase
        title={t('filters.brands')}
        openByDefault={true}
        shouldBeHidden={!brandsOptions || brandsOptions?.length === 0}
        showTopSeparator={false}
      >
        <BrandsListFilter
          {...({
            brands: (brandsOptions as any) ?? [],
            searchEnabled: undefined as any,
          } as any)}
        />
      </FilterBase>

      <FilterBase
        title={t('filters.earnRate')}
        openByDefault={true}
        shouldBeHidden={!earnRateOptions || earnRateOptions?.length === 0}
        showTopSeparator={false}
      >
        <EarnRatesFilter
          options={earnRateOptions ?? []}
          searchEnabled={false}
        />
      </FilterBase>
    </div>
  )
}

export { SideFilters }
